import { useQuery } from "@tanstack/react-query";

import { getProductBasicInfo } from "../core/product.core";

export default function useProductBasicInfo(productId?: string) {
  return useQuery({
    queryKey: ["productBasicInfo", productId],
    queryFn: (context) => getProductBasicInfo(context.queryKey[1] as string),
    enabled: !!productId,
  });
}
